export default __webpack_public_path__ + "static/media/X.cd2e18c7.svg";